// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
  apiKey: "AIzaSyCfJdSel4BQnsUzBizLf3pI4a3EsNWUVD0",
  authDomain: "rfideardley.firebaseapp.com",
  databaseURL: "https://rfideardley.firebaseio.com",
  projectId: "rfideardley",
  storageBucket: "rfideardley.appspot.com",
  messagingSenderId: "882478629645",
  appId: "1:882478629645:web:809c843867513290d4e644",
  measurementId: "G-DV0WHHFWZ1"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

